export const api = process.env.NODE_ENV === "production"
  ? process.env.NEXT_PUBLIC_API_URL_PROD
  : process.env.NEXT_PUBLIC_API_URL_DEV;

export const UPLOADS_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_UPLOADS_URL_DEV
    : process.env.NEXT_PUBLIC_UPLOADS_URL_PROD;

export const BACKEND_URL =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_BACKEND_URL_PROD
    : process.env.NEXT_PUBLIC_BACKEND_URL_DEV;
